import { EInputValidationResultType } from "../../../../commonreact/main/factorys/inputvalidation/enums/InputValidationEnums";

interface IProps {
  onSetValue?: () => void
}

/**
 * @abstract object that handels input validation
 */
export default class InputValidationResult {

  public static getItem(props: IProps): InputValidationResult { return new InputValidationResult(props); }

  private _value: EInputValidationResultType = EInputValidationResultType._null;
  public set value(it: EInputValidationResultType) {
    this._value = it;
    this.props.onSetValue ? this.props.onSetValue() : null;
  };
  public get value(): EInputValidationResultType { return this._value; }

  public get isValid(): boolean {
    if(this.value == EInputValidationResultType.Error) return false;
    return true;
    //hint: if not set, because f.e. it is not used in the frontend, return true 
    // if(this.value == EInputValidationResultType._null) return true
    // if(this.value == EInputValidationResultType.Hint) return true
    // if(this.value == EInputValidationResultType.Valid) return true
    // return false
  }

  public reset() {
    this._value = EInputValidationResultType._null; 
  }

  constructor(private props: IProps) {
  }
}